module.exports = __webpack_public_path__ + "img/r-203.fd69490e.jpg";